import React from "react";
import { API_URL } from "../../constants/api";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  REQUEST_STATUS,
  SECTIONS,
  TOOLTIP_LABEL,
  standardDateFormat
} from "../../constants/appConstants";
import { setSPSToken, getSPSTokenData } from "../../constants/constants";
import uniqBy from "lodash/uniqBy";
import {
  IsSectionVisible,
  removeDuplicates,
  IsTenant,
  IsTenantAdmin,
  getToolTipText,
  IsAdmin,
  PaperComponent,
  sortArray,
  GetUserConfiguration,
  GetEnableProperty
} from "../../utils/helper";
import {
  apiBatchRequestWithCache,
  apiDelete,
  apiRequest
} from "../../utils/api_service";
import DownloadSSRSPopUp from "../common/button-download-popup";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import "./requests.less";
import sortBy from "lodash/sortBy";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";
import AddUpdateRequest from "./addUpdateRequest";
import PaginationControlled from "../common/pagination/pagination";
import TableHeaderWithFilter from "../common/table-header-filter";
import { convertToLocalDate, getDiffInDays } from "../../utils/date";
import { filterTableRows } from "../../utils/filtered";
import { getArrayIndex } from "../../utils/lodash";
import { downloadExcelReportByAPI } from "../../utils/downloading";
import { Request_List } from "../../constants/ssrs_api";
import { convertIntoDDFormat } from "../../utils/generic";
import moment from "moment";
import FilterOff from "../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteIcon from "@material-ui/icons/Delete";
import { ShowToast, toastType } from "../../utils/toast-service";
import { IoMdCloseCircleOutline } from "react-icons/io";

class RequestsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestList: [],
      isOpenDeleteConfirmationPanel: false,
      editableData: "",
      isShowColFilter: true,
      isOpenAddUpdate: props.isOpenCreateRequest
        ? props.isOpenCreateRequest
        : false,
      masterData: "",
      userDetails: "",
      pageNo: 0,
      urlRequestId: "",
      rowsPerPagination: 25,
      colFilteredObj: [
        { keyName: "createdDate", value: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}`, filterType: "dateRange" }
      ],
      sortByColKey: "",
      reload: false,
      selectedSource:  [],
      selectedIds: {createdDate: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}` },
      refreshFilteredObj: false,
      clearData: false,
      keepFilterData: false,
      notificationProps: props.notificationProps,
      reasonForDelete: "",
      toolTipData: [],
      refreshData: false,
      viewAll: false,
      selectedData: "",
      header: "",
      numberOfRecord: 0
    };
  }

  /**
   * fetch data from new props
   * @param {*} newProps
   * @param {*} state
   * @returns
   */
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.notificationProps !== (state || {}).notificationProps ||
      newProps.notificationProps?.isReply !==
        (state || {}).notificationProps?.isReply ||
      newProps.notificationProps?.createdOn !==
        (state || {}).notificationProps?.createdOn ||
      newProps.notificationProps?.message !==
        (state || {}).notificationProps?.message ||
      newProps.notificationProps?.recordId !==
        (state || {}).notificationProps?.recordId
    ) {
      const data = (state?.requestList || []).filter(
        x =>
          x.requestId.toString() ===
          newProps.notificationProps?.recordId.toString()
      )[0] || { requestId: newProps.notificationProps?.recordId };
      return {
        notificationProps: newProps.notificationProps,
        isOpenAddUpdate: newProps?.notificationProps ? true : false, //newProps.notificationProps?.isOpenRequest,
        editableData: newProps.notificationProps ? data : "",
        sortByColKey: "",
        clearData: false,
        message: newProps.notificationProps?.message,
        createdOn: newProps.notificationProps?.createdOn
      };
    } else {
      return state;
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const URLsearch = window.location.search;
    if (URLsearch && URLsearch.indexOf("requestId") !== -1) {
      this.setState({
        urlRequestId: atob(URLsearch.split("=")[1]),
        isOpenAddUpdate: true,
        sortByColKey: ""
      });
    }
    /**
     * fetch list data
     */
    this.getMasterData();
    this.getRequestList();
    this.getTokenSpsData();
  }

  /**
   * reset page
   */
  resetPage = () => {
    const { reload } = this.state;

    this.setState(
      {
        colFilteredObj: [
          { keyName: "createdDate", value: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}`, filterType: "dateRange" }
        ],
        selectedIds: {createdDate: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}` },
        reload: !reload,
        refreshData: true
      },
      () => {
        this.getRequestList();
      }
    );
  };

  /**
   * get share point token data
   */
  getTokenSpsData = () => {
    if (!getSPSTokenData()) {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
        }
      });
    }
  };

  /** Master date */
  getMasterData = () => {
    apiBatchRequestWithCache([
      {
        url: API_URL.masterData.GetRequestMasterData,
        key: "masterData",
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.request.GetUserSiteInfo,
        key: "userDetails",
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.request.GetRequestTypesForUser,
        key: "requestSupportMaster",
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.masterData.GetLabels,
        key: "toolTipData",
        params: { sectionId: SECTIONS.REQUEST_LISTING },
        fromCache: true,
        duration: 15
      }
    ]).then(
      ({ masterData, userDetails, requestSupportMaster, toolTipData }) => {
        this.setState({
          requestSupportMaster: uniqBy(requestSupportMaster?.data, function(x) {
            return [x.RequestTypeId, x.PropertyId].join();
          }),
          masterData: masterData?.data,
          userDetails: userDetails?.data,
          toolTipData: toolTipData?.data
        });
      }
    );
  };

  /**
   * delete confirmation panel
   * @param {*} requestId
   */
  openDeleteConfirmationPanel = (isOpen, requestId) => {
    this.setState({
      requestId: requestId,
      isOpenDeleteConfirmationPanel: isOpen
    });
  };

  /**
   * delete request
   * @param {*} res
   */
  deleteRequest = res => {
    if (res == true) {
      const { requestId, reasonForDelete, toolTipData } = this.state;
      if (reasonForDelete && reasonForDelete?.trim().length > 0) {
        apiDelete({
          url:
            API_URL.request.DeleteRequest +
            "?requestId=" +
            requestId +
            "&reasonForDelete=" +
            reasonForDelete
        }).then(response => {
          response.success == false
            ? ShowToast(
                "Server Error: Unable to delete Request.",
                toastType.ERROR,
                5000,
                500
              )
            : ShowToast(
                "Request has been deleted successfully.",
                toastType.SUCCESS,
                5000,
                200
              );
          this.setState(
            {
              isOpenDeleteConfirmationPanel: false,
              reasonForDelete: false,
              requestId: 0
            },
            () => {
              this.getRequestList();
            }
          );
        });
      } else {
        ShowToast(
          getToolTipText(toolTipData, TOOLTIP_LABEL.REASON_FOR_DELETE) +
            " is required.",
          toastType.ERROR,
          5000,
          500
        );
      }
    } else {
      this.setState({
        isOpenDeleteConfirmationPanel: false,
        reasonForDelete: "",
        requestId: 0
      });
    }
  };

  /**
   * Request list
   * @param {*} bit
   */
  getRequestList = (bit = 0) => {
    const { reload, notificationProps, colFilteredObj,rowsPerPagination, pageNo, masterData, userDetails } = this.state;
    const dateFilter = colFilteredObj.filter(f => f.keyName == "createdDate")[0]
    ?.value;
    const userDetailData = GetUserConfiguration();
    const accessGroupId = userDetailData?.groups[0].accessGroupId;
    let fromDate = "";
    let toDate = "";
    if (dateFilter && dateFilter.length > 0) {
      fromDate = dateFilter.split("-")[0] === "" || dateFilter.split("-")[0] === null || dateFilter.split("-")[0] === "null" ? "" : dateFilter.split("-")[0];
      toDate = dateFilter.split("-")[1] === "" || dateFilter.split("-")[1] === null || dateFilter.split("-")[1] === "null" ? "" : dateFilter.split("-")[1];
    }
    const requestCode =
      colFilteredObj.filter(f => f.keyName == "requestCode")[0]?.value;
    const requesterName =
      colFilteredObj.filter(f => f.keyName == "requesterName")[0]?.value;
    const tenantName =
      colFilteredObj.filter(f => f.keyName == "tenantName")[0]?.value;
    const requestedFor =
      colFilteredObj.filter(f => f.keyName == "requestedFor")[0]?.value;
    const requestType =
      colFilteredObj
        .filter(f => f.keyName == "requestType")[0]
        ?.value.toString() || "All";
    const requestStatus =
      colFilteredObj
        .filter(f => f.keyName == "requestStatus")[0]
        ?.value.toString() || "All";
    const badgeType =
      colFilteredObj
        .filter(f => f.keyName == "badgeType")[0]
        ?.value.toString() || "All";

    const selectedAttachment = colFilteredObj.filter(f => f.keyName == "attachment")[0]
        ?.value?.join(",");
        let attachment = "";
        if (selectedAttachment && selectedAttachment.length > 0) {
          selectedAttachment.split(",").map(function(r) {
            if (r != "All") {
              attachment += r;
            } else attachment = "";
          });
          if (attachment.slice(-1) == ",") {
            attachment = attachment.slice(0, -1);
          }
    }

    const recordEntryType =
      colFilteredObj
        .filter(f => f.keyName == "recordEntryType")[0]
        ?.value.toString() || "All";
    const property =
      colFilteredObj
        .filter(f => f.keyName == "propertyName")[0]
        ?.value.toString() || "All";
    let requestTypeId = "";
    let requestStatusId = "";
    let propertyId = "";
    let badgeTypeId = "";
    let recordEntryTypeId = ""

    if (requestType && requestType.length > 0) {
      requestType.split(",").map(function(r) {
        if (r != "All") {
          requestTypeId +=
            masterData?.requestTypeMaster.filter(f => f.RequestType == r)[0]
              ?.RequestTypeId + ",";
        } else requestTypeId = "";
      });
      if (requestTypeId.slice(-1) == ",") {
        requestTypeId = requestTypeId.slice(0, -1);
      }
    }

    if (requestStatus && requestStatus.length > 0) {
      requestStatus.split(",").map(function(r) {
        if (r != "All") {
          requestStatusId +=
            masterData?.requestStatusMaster.filter(f => f.RequestStatus == r)[0]
              ?.RequestStatusId + ",";
        } else requestStatusId = "";
      });
      if (requestStatusId.slice(-1) == ",") {
        requestStatusId = requestStatusId.slice(0, -1);
      }
    }

    if (property && property.length > 0) {
      property.split(",").map(function(r) {
        if (r != "All") {
          propertyId +=
            userDetails.filter(f => f.PropertyName == r)[0]?.PropertyId + ",";
        } else propertyId = "";
      });
      if (propertyId.slice(-1) == ",") {
        propertyId = propertyId.slice(0, -1);
      }
    }

    if (badgeType && badgeType.length > 0) {
      badgeType.split(",").map(function(r) {
        if (r != "All") {
          badgeTypeId +=
            masterData?.badgeTypeMaster.filter(f => f.BadgeType == r)[0]
              ?.BadgeTypeId + ",";
        } else badgeTypeId = "";
      });
      if (badgeTypeId.slice(-1) == ",") {
        badgeTypeId = badgeTypeId.slice(0, -1);
      }
    }

    if (recordEntryType && recordEntryType.length > 0) {
      recordEntryType.split(",").map(function(r) {
        if (r != "All") {
          recordEntryTypeId +=
            masterData?.recordEntryMaster.filter(f => f.RecordEntryType == r)[0]
              ?.RecordEntryTypeId + ",";
        } else recordEntryTypeId = "";
      });
      if (recordEntryTypeId.slice(-1) == ",") {
        recordEntryTypeId = recordEntryTypeId.slice(0, -1);
      }
    }
    const params = {
      accessGroupId: accessGroupId,
      startDate: fromDate,
      endDate: toDate,
      pageSize: rowsPerPagination,
      pageNumber: (pageNo + 1),
      requestCode,
      requesterName,
      requestedFor,
      requestTypeId,
      badgeTypeId,
      requestStatusId,
      propertyId,
      tenantName,
      attachment,
      recordEntryTypeId     
    }
    apiRequest({
      url: API_URL.request.GetRequestsList,
      params
    }).then(({ data: response }) => {
      this.setState({
        requestList: response.requestData,
        keepFilterData: bit == 1 ? true : false,
        reload: bit == 1 ? !reload : reload,
        numberOfRecord: response.recordCount?.length === 1 ? response.recordCount[0] : 0,
        clearData: false,
        selectedSource: colFilteredObj
      });
      if (notificationProps !== undefined) {
        if ( notificationProps.recordId != undefined) {
          const data =
          response.requestData.filter(
              x =>
                x.requestId.toString() === notificationProps.recordId.toString()
            )[0] || {};
          this.onEditClicked(true, data);
        }
      }
    });
  };

  /**
   * call on save click
   */
  onSave = () => {
    const { reload, colFilteredObj } = this.state;
    this.setState(
      {
        requestList: [],
        isOpenAddUpdate: false,
        sortByColKey: "",
        keepFilterData: true,
        reload: !reload,
        clearData: false,
        selectedSource: colFilteredObj,
        refreshData: false
      },
      () => {
        this.getRequestList(1);
      }
    );
  };

  /**
   * call on edit button
   * @param {*} isOpen
   * @param {*} editRow
   */
  onEditClicked = (isOpen = false, editRow = "") => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: editRow,
      sortByColKey: "",
      clearData: false,
      refreshData: false
    });
  };

  /** call on add button */
  onAddButtonClicked = (isOpen = false) => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: ""
    });
  };

  /** set state value */
  setStateVal = (key, value) => {
    this.setState({ [key]: value });
  };

  /** Refresh request */
  refreshRequest = (isCalledGet = true) => {
    const { reload, colFilteredObj } = this.state;

    this.clearSearchRequestId();
    this.setState(
      {
        isOpenAddUpdate: false,
        editableData: "",
        sortByColKey: "",
        keepFilterData: true,
        reload: !reload,
        selectedSource: colFilteredObj,
        clearData: false,
        notificationProps: undefined,
        refreshData: false
      },
      () => {
        isCalledGet && this.getRequestList(1);
        this.props.handelOpenRequest();
      }
    );
  };

  /** update row count */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination }, ()=> {
      this.getRequestList();
    });
  };

  /** clear search requestId */
  clearSearchRequestId = () => {
    this.props.history.replace({
      search: ""
    });
  };

  /**
   * get filtered data depends upon conditions
   * @param {*} data
   * @returns
   */
  getFilteredData = data => {
    const { colFilteredObj, sortByColKey } = this.state;
    const fData = sortBy(
      filterTableRows(data, colFilteredObj, null, [{ key: "createdDate" }]),
      x => x[sortByColKey]
    );
    return fData || [];
  };

  /**
   * update column filter based on conditions
   * @param {*} key - key
   * @param {*} value - value
   * @param {*} filterType - type of filter
   */
  updateColumnFilter = (key, value = "", filterType, bitValue, obj) => {
    const { colFilteredObj, selectedIds, clearData } = this.state;
    const perviousColFilteredObj = [...colFilteredObj]
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0,
          refreshData: false
        }, () => {
          if (clearData != true) {          
            if ((obj?.filterType === undefined && (value?.length >= obj?.maxLength || (value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value && value?.length == 0))) || (obj?.filterType !== undefined && obj?.maxLength === undefined && value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value)) {
              this.getRequestList();
            }
          }
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0,
          refreshData: false
        }, () => {
          if (clearData != true) {          
            if ((obj?.filterType === undefined && (value?.length >= obj?.maxLength || (value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value && value?.length == 0))) || (obj?.filterType !== undefined && obj?.maxLength === undefined && value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value)) {
              this.getRequestList();
            }
          }
        });
    }
  };

  /** Download SSRS report */
  downloadSSRSReport = (report, type = "excel") => {
    const { colFilteredObj, userDetails, masterData } = this.state;
    const requestCode =
      colFilteredObj.filter(f => f.keyName == "requestCode")[0]?.value || "All";
    const requesterName =
      colFilteredObj.filter(f => f.keyName == "requesterName")[0]?.value ||
      "All";
    const tenantName =
      colFilteredObj.filter(f => f.keyName == "tenantName")[0]?.value || "All";
    const requestedFor =
      colFilteredObj.filter(f => f.keyName == "requestedFor")[0]?.value ||
      "All";
    const requestType =
      colFilteredObj
        .filter(f => f.keyName == "requestType")[0]
        ?.value.toString() || "All";
    const requestStatus =
      colFilteredObj
        .filter(f => f.keyName == "requestStatus")[0]
        ?.value.toString() || "All";
    const badgeType =
      colFilteredObj
        .filter(f => f.keyName == "badgeType")[0]
        ?.value.toString() || "All";

    const attachment =
      colFilteredObj
        .filter(f => f.keyName == "attachment")[0]
        ?.value.toString() || "All";
    const attachmentLength =
      attachment.split(",").length == 3 ? "All" : attachment;
    const property =
      colFilteredObj
        .filter(f => f.keyName == "propertyName")[0]
        ?.value.toString() || "All";
    const dateFilter = colFilteredObj.filter(f => f.keyName == "createdDate")[0]
      ?.value;

    const recordEntryType =
      colFilteredObj
      .filter(f => f.keyName == "recordEntryType")[0]
      ?.value.toString() || "All";

    let fromDate = "IsNull=True";
    let toDate = "IsNull=True";
    if (dateFilter && dateFilter.length > 0) {
      fromDate = dateFilter.split("-")[0] === "" || dateFilter.split("-")[0] === null || dateFilter.split("-")[0] === "null" ? "IsNull=True" : dateFilter.split("-")[0];
      toDate = dateFilter.split("-")[1] === "" || dateFilter.split("-")[1] === null || dateFilter.split("-")[1] === "null" ? "IsNull=True" : dateFilter.split("-")[1];
    }
    const dateOffset = moment().utcOffset();
    let requestTypeId = "";
    let requestStatusId = "";
    let propertyId = "";
    let badgeTypeId = "";
    let recordEntryTypeId = "";

    if (requestType && requestType.length > 0) {
      requestType.split(",").map(function(r) {
        if (r != "All") {
          requestTypeId +=
            masterData?.requestTypeMaster.filter(f => f.RequestType == r)[0]
              ?.RequestTypeId + ",";
        } else requestTypeId = "All,";
      });
      if (requestTypeId.slice(-1) == ",") {
        requestTypeId = requestTypeId.slice(0, -1);
      }
    }

    if (requestStatus && requestStatus.length > 0) {
      requestStatus.split(",").map(function(r) {
        if (r != "All") {
          requestStatusId +=
            masterData?.requestStatusMaster.filter(f => f.RequestStatus == r)[0]
              ?.RequestStatusId + ",";
        } else requestStatusId = "All,";
      });
      if (requestStatusId.slice(-1) == ",") {
        requestStatusId = requestStatusId.slice(0, -1);
      }
    }

    if (property && property.length > 0) {
      property.split(",").map(function(r) {
        if (r != "All") {
          propertyId +=
            userDetails.filter(f => f.PropertyName == r)[0]?.PropertyId + ",";
        } else propertyId = "All,";
      });
      if (propertyId.slice(-1) == ",") {
        propertyId = propertyId.slice(0, -1);
      }
    }

    if (badgeType && badgeType.length > 0) {
      badgeType.split(",").map(function(r) {
        if (r != "All") {
          badgeTypeId +=
            masterData?.badgeTypeMaster.filter(f => f.BadgeType == r)[0]
              ?.BadgeTypeId + ",";
        } else badgeTypeId = "All,";
      });
      if (badgeTypeId.slice(-1) == ",") {
        badgeTypeId = badgeTypeId.slice(0, -1);
      }
    }

    if (recordEntryType && recordEntryType.length > 0) {
      recordEntryType.split(",").map(function(r) {
        if (r != "All") {
          recordEntryTypeId +=
            masterData?.recordEntryMaster.filter(f => f.RecordEntryType == r)[0]
              ?.RecordEntryTypeId + ",";
        } else recordEntryTypeId = "All,";
      });
      if (recordEntryTypeId.slice(-1) == ",") {
        recordEntryTypeId = recordEntryTypeId.slice(0, -1);
      }
    }

    const param = //"&ShowAll=" + isShowAll  +
      "&RequestCode=" +
      requestCode +
      "&RequesterName=" +
      requesterName +
      "&RequestTypeId=" +
      requestTypeId +
      "&RequestStatusId=" +
      requestStatusId +
      "&BadgeTypeId=" +
      badgeTypeId +
      "&Attachment=" +
      attachmentLength +
      "&TenantName=" +
      tenantName +
      "&RequestedFor=" +
      requestedFor +
      "&PropertyId=" +
      propertyId +
      (fromDate == "IsNull=True" ? "&FromDate:" : "&FromDate=") +
      fromDate +
      (toDate == "IsNull=True" ? "&ToDate:" : "&ToDate=") +
      toDate +
      "&CreatedDateOffset=" +
      dateOffset +
     "&RecordEntryTypeId=" +
      recordEntryTypeId;
    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }
  };

  /** get color class */
  getColorClass(no) {
    if (no > 30) return "alertText";
    else if (no <= 30 && no > 15) return "warningText";
    else return "";
  }

  /** clear filter values */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;
    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {},
      refreshData: false     
    }, () => {
      this.getRequestList();
    });
  };

  /**
   * set value of reason
   * @param {*} e
   */
  handleChange = e => {
    this.setState({
      reasonForDelete: e.target.value || ""
    });
  };

  /**
   * set the data when click on count
   * @param {*} viewAll 
   * @param {*} selectedData 
  */
  handleViewAllData = (viewAll = false, selectedData, header) => {
    this.setState({
      viewAll: viewAll,
      selectedData: selectedData,
      header: header
    });
  };

  render() {
    const isTenant = IsTenant();
    const isTenantAdmin = IsTenantAdmin();

    const {
      requestList,
      editableData,
      isShowColFilter,
      isOpenAddUpdate,
      masterData,
      userDetails,
      requestSupportMaster,
      urlRequestId,
      colFilteredObj,
      toolTipData,
      reasonForDelete,
      isOpenDeleteConfirmationPanel,
      refreshFilteredObj,
      pageNo,
      rowsPerPagination,
      clearData,
      selectedIds,
      keepFilterData,
      reload,
      selectedSource,
      createdOn,
      message,
      refreshData,
      viewAll,
      header,
      selectedData,
      numberOfRecord
    } = this.state;
    const requestListing = IsSectionVisible(
      SECTIONS.REQUEST,
      SECTIONS.REQUEST_LISTING
    );


    const addRequestVisible = IsSectionVisible(
      SECTIONS.REQUEST,
      SECTIONS.CREATE_REQUEST
    );

    const requestFilteredList = requestList;
    const optionsListForRequestType = uniqBy(
      convertIntoDDFormat(
        masterData.requestTypeMaster || [],
        "RequestType",
        "RequestType"
      ),
      x => x.id
    );

    const optionsListForRequestStatus = uniqBy(
      convertIntoDDFormat(
        (masterData.requestStatusMaster || []).filter(x=> x.NewGrantAccessProcess === true),
        "RequestStatus",
        "RequestStatus"
      ),
      x => x.id
    );

    const optionsListForRecordMaster = uniqBy(
      convertIntoDDFormat(
        (masterData.recordEntryMaster || []),
        "RecordEntryType",
        "RecordEntryType"
      ),
      x => x.id
    );

    let propertyData = uniqBy(
      convertIntoDDFormat(userDetails || [], "PropertyId", "PropertyName"),
      x => x.id
    );
    propertyData = GetEnableProperty((propertyData || []), SECTIONS.REQUEST_LISTING, "id");
    
    const optionsListForDataCenter =  uniqBy(
      convertIntoDDFormat(propertyData || [], "value", "value"),
      x => x.id
    );

    const optionsListForBadgeType = uniqBy(
      convertIntoDDFormat(
        masterData.badgeTypeMaster || [],
        "BadgeType",
        "BadgeType"
      ),
      x => x.id
    );

    return (
      <div className={"col-xs-12"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className={"requests-wrapper"}>
              <div className={"requests-breadcrumb-wrapper"}>
                <div className={"requests-breadcrumb"}>
                  {"HOME | "}
                  <span>{"Request"}</span>
                  {isOpenAddUpdate && editableData == ""
                    ? " | Create Request"
                    : ""}
                  {isTenant && editableData && editableData != ""
                    ? " | Edit Request"
                    : ""}
                  {!isTenant && editableData && editableData != ""
                    ? " | Edit Request"
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isOpenAddUpdate ? (
          userDetails && (
            <AddUpdateRequest
              masterData={masterData}
              requestTypeId={editableData ? editableData.requestTypeIds : null}
              propertyId={editableData ? editableData.propertyId : null}
              requestSupportMaster={
                isTenant ? requestSupportMaster : masterData.requestTypeMaster
              }
              createdOn={createdOn}
              message={message}
              userDetails={userDetails}
              requestId={editableData?.requestId ?? urlRequestId}
              setStateVal={this.onEditClicked}
              onSave={this.onSave}
              refreshRequest={this.refreshRequest}
            />
          )
        ) : (
          <>
            <div className={"row"}>
              <div className={"col-xs-10"} style={{ display: "flex" }}>
                {addRequestVisible && (
                  <Button
                    variant={"contained"}
                    size={"small"}
                    onClick={() => this.onAddButtonClicked(true)}
                    style={{ height: "32px", fontSize: "0.628rem" }}
                  >
                    {"Create Request\r"}
                  </Button>
                )} &nbsp; &nbsp;
                <FormControlLabel
                  className={"show-filter"}
                  control={
                    <Checkbox
                      id={"filterCompletedOrCancelled"}
                      color={"primary"}
                      defaultValue={isShowColFilter}
                      checked={isShowColFilter}
                      onChange={event =>
                        this.setState({
                          isShowColFilter: event.target.checked,
                          colFilteredObj: [],
                          clearData: true,
                          refreshFilteredObj: !refreshFilteredObj,
                          sortByColKey: "",
                          selectedIds: {}
                        })}
                    />
                  }
                  label={"Show Filters"}
                />
            
                <DownloadSSRSPopUp
                  buttonLabel={"Print"}
                  dataTip={getToolTipText(toolTipData, TOOLTIP_LABEL.DOWNLOAD)}
                  reportList={[
                    {
                      label: "Request List",
                      id: 1,
                      pdfDownload: true,
                      excelDownload: true,
                      downloadLink: Request_List
                    }
                  ]}
                  downloadBtnLabel={"Download"}
                  downloadReport={this.downloadSSRSReport}
                />
                <Tooltip
                  title={getToolTipText(
                    toolTipData,
                    TOOLTIP_LABEL.CLEAR_FILTER
                  )}
                  placement={"bottom"}
                >
                  <img
                    className={"icons"}
                    src={FilterOff}
                    alt={"logo"}
                    onClick={() => {
                      this.clearFilter();
                    }}
                  />
                </Tooltip>
              </div>
              <div className={"col-xs-2 end-xs"}>
                <Tooltip
                  title={getToolTipText(toolTipData, TOOLTIP_LABEL.REFRESH)}
                  placement={"bottom"}
                >
                  <IconButton size={"small"} onClick={() => this.resetPage()}>
                    <RefreshIcon
                      style={{
                        fill: "#365E7E",
                        marginTop: "7px",
                        width: "28px",
                        height: "30px"
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <div className={"row content"} />
            <div className={"request-list-table-div"}>
              {requestListing ? (
                <table
                  className={"request-list-table"}
                  style={{ fontWeight: "200 !important" }}
                >
                  <thead>
                    <tr
                      className={"blue-cust-title"}
                      style={{ borderTop: "3px solid #FFFFFF" }}
                    >
                      <th
                        colSpan={12}
                        style={{
                          fontSize: "15px",
                          textAlign: "center",
                          lineHeight: "25px"
                        }}
                      >
                        {"Requests\r"}
                      </th>
                    </tr>
                    <TableHeaderWithFilter
                      clearData={clearData}
                      refreshData={refreshData}
                      isDefaultFilter
                      refreshFilteredObj={refreshFilteredObj}
                      selectedId={selectedIds}
                      reload={reload}
                      keepFilterData={keepFilterData}
                      selectedSource={selectedSource}
                      columnData={[
                        {
                          headerClass: "w-10",
                          colName: "Request #",
                          keyName: "requestCode",
                          maxLength: 3
                        },
                        {
                          headerClass: "w-10",
                          colName: "Requester Name",
                          keyName: "requesterName",
                          maxLength: 3,
                          trim:  false
                        },
                        {
                          headerClass: "w-15",
                          colName: "Requested For",
                          keyName: "requestedFor",
                          maxLength: 3,
                          trim:  false
                        },
                        {
                          headerClass: "w-10",
                          colName: "Request Type",
                          keyName: "requestType",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.requestType,
                          optionsList: optionsListForRequestType
                        },
                        {
                          headerClass: "w-13",
                          colName: "Badge Type",
                          keyName: "badgeType",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.badgeType,
                          optionsList: optionsListForBadgeType
                        },
                        {
                          headerClass: "w-10",
                          colName: "Request Status",
                          keyName: "requestStatus",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.requestStatus,
                          optionsList: optionsListForRequestStatus
                        },
                        {
                          headerClass: "w-13",
                          colName: "Data Center",
                          keyName: "propertyName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.propertyName,
                          optionsList: optionsListForDataCenter
                        },
                        {
                          headerClass: "w-10",
                          colName: "Tenant Name",
                          keyName: "tenantName",
                          maxLength: 3,
                          trim:  false
                        },
                        {
                          headerClass: "w-15",
                          colName: "Created Date",
                          keyName: "createdDate",
                          filterType: "dateRange",
                          isApiCall: true,
                          className: "bold-text-value",
                          toolTip:
                            "Yellow -15 days not completed from Create Date.  Red -  30 days not completed from Create Date."
                        },
                        {
                          headerClass: "w-5",
                          colName: "Attachment",
                          keyName: "attachment",
                          width: "75px",
                          filterType: "multiSelect",
                          optionsList: [
                            { id: "No", value: "No" },
                            { id: "Yes", value: "Yes" }
                          ]
                        },
                        {
                          headerClass: "w-5",
                          colName: "Record Entry Type",
                          keyName: "recordEntryType",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.recordEntryType,
                          optionsList: optionsListForRecordMaster,
                          width: "75px"                         
                        },
                        {
                          headerClass: "w-10",
                          colName: "Action",
                          isHideFilter: true
                        }
                      ]}
                      isShowFilter={isShowColFilter}
                      onChangeFilter={this.updateColumnFilter}
                    />
                  </thead>

                  <tbody>
                    {requestFilteredList && requestFilteredList.length > 0 ? (
                      (
                        (requestFilteredList) || []
                      ).map((item, index) => (
                        <tr key={"requests" + index}>
                          <td>
                            {item.requestCode == null ? "-" : item.requestCode}
                          </td>

                          <td>
                            {item.requesterName == null
                              ? "-"
                              : item.requesterName}
                          </td>
                          <td>
                            {item.requestedFor == null
                              ? "-"
                              : item.requestedFor}
                          </td>
                          <td>
                            {item.requestType == null
                              ? "-"
                              : removeDuplicates(
                                  item.requestType.split(",")
                                )?.map((obj, index) => (
                                  <Chip
                                    key={"chip" + index + "c"}
                                    label={obj}
                                    style={{
                                      margin: 1,
                                      fontSize: "0.7rem",
                                      height: "1.8rem"
                                    }}
                                  />
                                ))}
                          </td>
                          <td>
                            {item.badgeType == null ? "" : item.badgeType}
                          </td>
                          <td>
                            {item.requestStatus == null
                              ? "-"
                              : item.requestStatus}
                          </td>
                          {!isTenant && !isTenantAdmin &&
                           <td style={{ cursor: "pointer", textAlign: "center" }}>
                            {item.propertyName == null ? (
                              "-"
                            ) : (
                              <>
                                <span
                                  className={"underline"}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "0.7rem",
                                  }}
                                  onClick={() =>
                                    this.handleViewAllData(
                                      true,
                                      item.propertyName,
                                      "Data Center"
                                    )}
                                >
                                  {
                                    removeDuplicates(item.propertyName.split(","))
                                      .length
                                  }
                                </span>
                              </>
                            )}
                           </td>}
                           {(isTenant || isTenantAdmin) && 
                             <td>
                             {item.propertyName == null
                               ? "-"
                               : item.propertyName}
                             </td>}
                          <td>
                            {item.tenantName == null ? "-" : item.tenantName}
                          </td>
                          {item.requestStatusId == REQUEST_STATUS.CREATED ||
                          item.requestStatusId == REQUEST_STATUS.DRAFT ||
                          item.requestStatusId == REQUEST_STATUS.INPROGRESS ||
                          item.requestStatusId ==
                            REQUEST_STATUS.WAITING_FOR_SIGNED_BRR ||
                          item.requestStatusId ==
                            REQUEST_STATUS.ABRF_APPROVED ||
                          item.requestStatusId ==
                            REQUEST_STATUS.AWAITING_FOR_ABRF ? (
                            <td>
                              <span
                                className={`colorText ${this.getColorClass(
                                  getDiffInDays(
                                    new Date(item.createdDate.split("T")[0]),
                                    new Date()
                                  )
                                )}`}
                              >
                                {convertToLocalDate(
                                  item.createdDate,
                                  "MM/DD/YYYY"
                                )}
                              </span>
                            </td>
                          ) : (
                            <td>
                              {convertToLocalDate(
                                item.createdDate,
                                "MM/DD/YYYY"
                              )}
                            </td>
                          )}
                          <td>
                            {item.attachment == null ? "-" : item.attachment}
                          </td>
                          <td>
                            {item.recordEntryType == null ? "-" : item.recordEntryType}
                          </td>
                          {(isTenantAdmin || !isTenant) &&
                          item.requestStatusId > REQUEST_STATUS.DRAFT ? (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={getToolTipText(
                                    toolTipData,
                                    TOOLTIP_LABEL.VIEW
                                  )}
                                  placement={"bottom"}
                                >
                                  <IconButton
                                    size={"small"}
                                    fontSize={"small"}
                                    onClick={() => this.onEditClicked(true, item)}
                                  >
                                    <VisibilityIcon
                                      fontSize={"small"}
                                      size={"small"}
                                    />
                                  </IconButton>
                                </Tooltip>
                                {IsAdmin() && (
                                  <Tooltip
                                    title={getToolTipText(
                                      toolTipData?.filter(
                                        x => x.LabelType === "Tooltip"
                                      ) || [],
                                      TOOLTIP_LABEL.DELETE
                                    )}
                                    placement={"bottom"}
                                  >
                                    <IconButton
                                      size={"small"}
                                      onClick={() =>
                                        this.openDeleteConfirmationPanel(
                                          true,
                                          item.requestId
                                        )}
                                    >
                                      <DeleteIcon
                                        fontSize={"small"}
                                        size={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                          ) : (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={getToolTipText(
                                    toolTipData,
                                    TOOLTIP_LABEL.EDIT
                                  )}
                                  placement={"bottom"}
                                >
                                  <IconButton
                                    size={"small"}
                                    onClick={() => this.onEditClicked(true, item)}
                                  >
                                    <EditIcon fontSize={"small"} size={"small"} />
                                  </IconButton>
                                </Tooltip>
                                {IsAdmin() && (
                                  <Tooltip
                                    title={getToolTipText(
                                      toolTipData?.filter(
                                        x => x.LabelType === "Tooltip"
                                      ) || [],
                                      TOOLTIP_LABEL.DELETE
                                    )}
                                    placement={"bottom"}
                                  >
                                    <IconButton
                                      size={"small"}
                                      onClick={() =>
                                        this.openDeleteConfirmationPanel(
                                          true,
                                          item.requestId
                                        )}
                                    >
                                      <DeleteIcon
                                        fontSize={"small"}
                                        size={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ textAlign: "center" }} colSpan={9}>
                          {"No data available\r"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                ""
              )}
            </div>
            {numberOfRecord && numberOfRecord > 0 ? (
              <div className={"paginationContainer"}>
                <PaginationControlled
                  tableLength={numberOfRecord}
                  updateRowCount={this.updateRowCount}
                  pageNo={pageNo}
                  rowsPerPagination={rowsPerPagination}
                />
              </div>
            ) : <></>}
            <ConfirmDialog
              size={"sm"}
              IsOpen={isOpenDeleteConfirmationPanel}
              Message={getToolTipText(
                toolTipData?.filter(x => x.LabelType === "Popup Message") || [],
                TOOLTIP_LABEL.DELETE
              )}
              OnHandelClick={this.deleteRequest}
              AgreeText={getToolTipText(toolTipData, TOOLTIP_LABEL.YES)}
              DisAgreeText={getToolTipText(toolTipData, TOOLTIP_LABEL.NO)}
              deleteConfig={{
                id: "reasonForDelete",
                value: reasonForDelete,
                action: this.handleChange,
                name: getToolTipText(
                  toolTipData,
                  TOOLTIP_LABEL.REASON_FOR_DELETE
                ),
                isDeleteReason: true
              }}
            />
          </>
        )}

        <Dialog
          open={viewAll || false}
          onClose={() => this.handleViewAllData(false, "", "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {header}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.handleViewAllData(false, "", "")}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedData &&
              sortArray(
                removeDuplicates(selectedData.split(","))
              )?.map((obj, index) => (
                <Chip
                  key={"chip" + index + "c"}
                  label={obj}
                  style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                />
              ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllData(false, "", "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default RequestsTable;
